import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useStandbyScheduleDetail = (id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [scheduleInfo, setScheduleInfo] = useState<ProjectScheduleInfoDto>();
  const [projectList, setProjectList] = useState<any[]>();
  const [lastInsertSrl, setLastInsertSrl] = useState<any>(0);

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading, refetch } = useQuery(
    [endpoints.project.schedule.standby, id],
    () =>
      fetcher.project.postStandbyScheduleInfo({id: id}),
    {
      enabled: (id > 0),
      
      onSuccess: (res: ProjectScheduleInfoResDto) => {
        switch (res.code) {
          case 200:
            setScheduleInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: standbyScheduleInsert, isLoading: isLoadingInsert, isSuccess: insertStandbySuccess } = useMutation(
    [endpoints.project.schedule.standby.add],
    fetcher.project.postStandbyScheduleInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            if (!!res.result) setLastInsertSrl(res.result.id)
            message.info(MSG.SUCCESS_INSERT, 1);
            break;
          case 400:
            alert(MSG.ERROR_DUP_EXCEPTPRICE);
            break;                          
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )


  const { mutate: standbyScheduleUpdate, isLoading: isLoadingUpdate, isSuccess: updateStandbySuccess, isIdle  } = useMutation(
    [endpoints.project.schedule.standby.update],
    fetcher.project.postStandbyScheduleUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          case 400:
            alert(MSG.ERROR_DUP_EXCEPTPRICE);
            break;              
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: standbyScheduleDelete, isLoading: isLoadingDelete, isSuccess: deleteStandbySuccess } = useMutation(
    [endpoints.project.schedule.standby.delete],
    fetcher.project.postStandbyScheduleDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;               
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  const { mutate: standbyProjectList } = useMutation(
    [endpoints.project.schedule.standby.projectList],
    fetcher.project.postStandbyProjectList,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            if (res.result) {
              setProjectList(res.result);
            }
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { 
    isLoading, 
    isLoadingInsert,
    isLoadingUpdate,
    isLoadingDelete,
    refetch, 
    lastInsertSrl, 
    scheduleInfo, 
    projectList,
    insertStandbySuccess, 
    updateStandbySuccess, 
    deleteStandbySuccess, 
    standbyScheduleInsert, 
    standbyScheduleUpdate, 
    standbyScheduleDelete,    
    standbyProjectList,
  };
};

export default useStandbyScheduleDetail;
